import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { PointInterest, Group, Vehicule } from 'src/app/model/data-managemnt';
import { RealTimeRecord } from 'src/app/model/real-time';
import { AlertController, PopoverController, NavController, ModalController, Platform } from '@ionic/angular';
import { PromptComponent } from './prompt/prompt.component';
import * as L from 'leaflet';
import { Router } from "@angular/router";
import { HeaderService } from 'src/app/header/header.service';
import { MapService } from 'src/app/utils/leaflet/service/map.service';
import { Map } from "leaflet";
import { DashboradComponent } from './dashborad/dashborad.component';
import { LoadingService } from 'src/app/utils/loading/loadingService';
import { TranslateService } from '@ngx-translate/core';
import { version } from 'src/app/global.config';
import { LaunchNavigator, LaunchNavigatorOptions } from '@ionic-native/launch-navigator';
import { RealtimeWorkerService } from './realtime-worker.service';
import { SigninService } from 'src/app/signin/signin.service';
import { PopupService } from './popup-rt/popup-rt.service';
import { StateService, ZoomState } from 'src/app/utils/leaflet/service/state.service';
import { MapNavigationService } from 'src/app/utils/map-top-toolbar/map-navigation.service';
import { AlertManagementService } from '../alert-management/alert-management.service';
import { DateInterval } from 'src/app/model/date-interval.model';
import { NotificationsComponent } from 'src/app/header/notifications/notifications.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

// Which content the bottom sheet / diamond button currently controls.
// 'none'        -> nothing chosen yet, diamond button does nothing
// 'realtime'    -> the real-time vehicle list (search bar + list)
// 'historique'  -> whatever historique sub-view was last chosen (trajets, kilometrage, etc.)
export type SheetView = 'none' | 'realtime' | 'historique';

@Component({
  selector: 'app-realtime',
  templateUrl: './realtime.component.html',
  styleUrls: ['./realtime.component.scss'],
})
export class RealtimeComponent implements OnInit, OnDestroy {
  @ViewChild('myTable', { static: false }) table: any;

  pointInterest: PointInterest = new PointInterest();
  engine = true;
  id1: any;
  id2: any;
  currentlocationlat: any;
  currentlocationlng: any;
  isClicked: boolean = false;
  positionMarker: any;
  selectedDevice: any;
  circle: any;
  rtMap: Map;
  isClickPop: boolean = false;
  tooltipEvent: 'click' | 'press' = 'click';
  showArrow: boolean = true;
  duration: number = 3000;
  private readonly STALE_THRESHOLD_MS = 2 * 60 * 60 * 1000; // 2 hours
  backButtonSubscription: any;
  searchVehicule: string = '';
  liveReloadingRT: any;
  reloadGetRealTimePath: boolean;
  hideRTPath: boolean;
  hideCurrentPath: boolean;
  latBegin: number;
  lngBegin: number;
  clickTrackDate: Date;
  trameRtTrack = [];
  loading = false;
  version: string;
  navigator: Navigator;
  ZoomState = ZoomState; // Expose ZoomState to the template
  showVehicleList = false;
  showSearchBar = false;
  notifications: any[] = [];
  dateInterval: DateInterval = new DateInterval();
  liveReloadingNotif: any;
  private destroy$ = new Subject<void>();
  private openGroupIds = new Set<number>();

  // --- Draggable bottom sheet state ---
  // sheetHeight is the live height (px) of the bottom menu, controlled by
  // free dragging of the grabber. It is clamped between min and max.
  sheetHeight = 86;
  sheetDragging = false;

  // --- Generic "active view" state for the diamond toggle button ---
  // activeView tracks WHICH content was last selected (realtime nav item,
  // or a historique option chosen from the historical submenu).
  // panelVisible tracks WHETHER that content is currently shown or hidden.
  // The diamond button only flips panelVisible; it never changes activeView.
  activeView: SheetView = 'realtime';
  panelVisible = false;
  historiqueData: any = null;
  // Optional: which historique sub-view is active (e.g. 'trajets', 'kilometrage').
  // Set this via openHistoriquePanel() when the historical submenu is wired up.
  activeHistoriqueKind: string | null = null;

  readonly minSheetHeight = 86;
  readonly searchBarHeight = 86 + 56;
  maxSheetHeight = 500;
  private sheetPointerActive = false;
  private sheetStartY = 0;
  private sheetStartHeight = 0;

  constructor(public realTimeWorker: RealtimeWorkerService, private alertCtrl: AlertController,
              private popoverCtrl: PopoverController,
              public mapService: MapService, private navCtrl: NavController,
              private router: Router, private headerService: HeaderService, private modalController: ModalController,
              private platform: Platform,
              public loadingService: LoadingService,
              public popupService: PopupService,
              private translate: TranslateService,
              public signinService: SigninService,
              public stateservice: StateService,
              private mapNavigationService: MapNavigationService,
              private alertManagementService: AlertManagementService,) {
    this.headerService.selectedTab = "realtime";
    this.version = version;
  }

  ngOnInit() {
    this.computeSheetBounds();
    try {

      this.realTimeWorker.init();
      this.initTimerNotif();
      this.mapNavigationService.goToRealtimeMap$
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => this.showRealtimeMap());
      this.realTimeWorker.dataManagementService.GroupsLoaded$
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => this.openAllGroupsInPanel());
      this.openAllGroupsInPanel();
      // Do not request GPS on startup — iOS can hang on requestPermissions if
      // Info.plist location keys are missing. GPS is requested only on Ma Position tap.

    } catch (ee) { }
  }

  ionViewWillEnter() {
    this.translate.setDefaultLang(this.translate.currentLang);
    this.backButtonSubscription = this.platform.backButton.subscribe(async () => {
      navigator['app'].exitApp();
    });

  }
  ionViewDidEnter() {
    console.log("ionViewDidEnter");

    if (this.mapService.preventMapDestroy) {
      this.mapService.preventMapDestroy = false;
    }

    // Keep search bar / vehicle list hidden on default load.
    // They open only via Temps réel nav or the diamond button.
    this.panelVisible = false;
    this.showVehicleList = false;
    this.showSearchBar = false;
    this.sheetHeight = this.minSheetHeight;

    setTimeout(() => this.bootstrapRealtimeMap(), 100);
  }

  private bootstrapRealtimeMap(): void {
    this.mapService.initMap(this.rtMap, 'rtMap');
    this.realTimeWorker.loadFocus();
    this.realTimeWorker.initTimer();
    this.stateservice.ManipulationMap();
    this.mapService.rtMarkers = [];
    this.mapService.removeAllRtMarkers();
    this.refreshRealtimeMapDisplay();
    setTimeout(() => this.refreshRealtimeMapDisplay(), 300);
    setTimeout(() => this.refreshRealtimeMapDisplay(), 600);
  }

  private refreshRealtimeMapDisplay(): void {
    if (!this.mapService.map) {
      return;
    }

    this.mapService.map.invalidateSize(true);

    const hasFocusedVehicle =
      this.realTimeWorker.trackingMode && !!this.realTimeWorker.dataManagementService.selectedVehicule;

    if (hasFocusedVehicle) {
      this.realTimeWorker.syncSelectedVehicleMarkerOnMap();
      return;
    }

    this.realTimeWorker.prepareGlobalFleetView();
    this.resetRealtimeMapView();
    this.realTimeWorker.restoreAllVehiclesOnMap();
    this.realTimeWorker.getAllRealTimeRecords();
  }

  private resetRealtimeMapView(): void {
    this.trameRtTrack = [];
    this.popupService.hideCurrentPath = true;
    this.popupService.showBackButton = false;
    this.stateservice.zoomCounter = 0;
    this.popupService.stopPlayback();

    if (!this.mapService.map) {
      return;
    }

    this.mapService.map.closePopup();
    if (this.popupService.isClicked) {
      this.mapService.map.removeLayer(this.popupService.positionMarker);
      this.mapService.map.removeLayer(this.popupService.circle);
      this.popupService.isClicked = false;
    }

    this.mapService.removePolylinesFromMap();
    this.mapService.removeMarkersFromMap();
    // Keep the default country zoom on first open. Fitting all vehicles
    // here zooms the map in as soon as the app starts.
    if (this.stateservice.getState() !== ZoomState.Default) {
      this.stateservice.updateState(ZoomState.Default);
    } else {
      this.stateservice.setSelectedMarker(null);
    }
  }

  ionViewWillLeave() {
    console.log("ionViewWillLeave");

    if (!this.mapService.preventMapDestroy && this.mapService.map) {
      this.mapService.map.remove();
    }
  }
  ionViewDidLeave() {
    console.log("ionViewDidLeave");
    clearTimeout(this.liveReloadingRT);
    clearTimeout(this.realTimeWorker.liveReloadingRT);
    this.backButtonSubscription.unsubscribe();

  }

  onFocus(event: any): void {
    this.realTimeWorker.loadFocus();
    this.realTimeWorker.initTimer();
  }



  ngOnDestroy() {
    try {
      if (this.realTimeWorker.allRealTimeRecords) {
        this.realTimeWorker.allRealTimeRecords.unsubscribe();
      }
    } catch (e) {

    }
    if (this.realTimeWorker.geocodingSubscription) {
      this.realTimeWorker.geocodingSubscription.unsubscribe();
    }
    if (this.realTimeWorker.markerWasAddedSubscription) {
      this.realTimeWorker.markerWasAddedSubscription.unsubscribe();
    }
    if (this.realTimeWorker.allGroups) {
      this.realTimeWorker.allGroups.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
    if (this.liveReloadingNotif) {
      clearInterval(this.liveReloadingNotif);
    }
  }

  loadNotification() {
    this.alertManagementService
      .getNotifications(this.dateInterval)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (notifications) => {
          this.notifications = notifications;
        },
        error: (err) => console.error('Error loading notifications:', err)
      });
  }

  initTimerNotif() {
    if (this.liveReloadingNotif) {
      clearInterval(this.liveReloadingNotif);
    }
    this.loadNotification();
    this.liveReloadingNotif = setInterval(() => {
      this.loadNotification();
    }, 20000);
  }

  async clickNotifications(ev: any) {
    this.realTimeWorker.prepareMapForOverlay();
    const dialog = await this.modalController.create({
      component: NotificationsComponent,
      showBackdrop: true,
      cssClass: 'notifDialog',
      componentProps: { notifications: this.notifications }
    });
    await dialog.present();
    await dialog.onDidDismiss();
    this.realTimeWorker.restoreMapAfterOverlay();
  }

  addPOI(realTimeRecord: RealTimeRecord) {
    this.pointInterest = new PointInterest;
    this.pointInterest.type = 0;
    this.pointInterest.coordinate = realTimeRecord.coordinate;
    this.pointInterest.address = realTimeRecord.geocodingDetails;
  }
  refreshFiles() {
    return new Date();
  }
  // ---------------- Draggable bottom sheet ----------------

  @HostListener('window:resize')
  computeSheetBounds() {
    this.maxSheetHeight = Math.max(
      Math.round(window.innerHeight * 0.85),
      this.minSheetHeight + 120
    );
    if (!this.panelVisible) {
      this.showVehicleList = false;
      this.showSearchBar = false;
    } else if (this.sheetHeight > this.maxSheetHeight) {
      this.sheetHeight = this.maxSheetHeight;
    }
  }

  onSheetDragStart(ev: MouseEvent | TouchEvent) {
    this.sheetPointerActive = true;
    this.sheetDragging = false;
    this.sheetStartY = this.getPointerY(ev);
    this.sheetStartHeight = this.sheetHeight;
  }

  @HostListener('document:mousemove', ['$event'])
  @HostListener('document:touchmove', ['$event'])
  onSheetDragMove(ev: MouseEvent | TouchEvent) {
    if (!this.sheetPointerActive) {
      return;
    }
    const delta = this.sheetStartY - this.getPointerY(ev);
    if (Math.abs(delta) > 3) {
      this.sheetDragging = true;
    }
    let height = this.sheetStartHeight + delta;
    height = Math.min(this.maxSheetHeight, Math.max(this.minSheetHeight, height));
    this.sheetHeight = height;

    const opened = height > this.minSheetHeight + 30;
    if (opened && !this.showVehicleList) {
      this.showVehicleList = true;
      this.expandAllGroups();
    } else if (!opened && this.showVehicleList) {
      this.showVehicleList = false;
    }
  }

  @HostListener('document:mouseup')
  @HostListener('document:touchend')
  onSheetDragEnd() {
    if (!this.sheetPointerActive) {
      return;
    }
    this.sheetPointerActive = false;
    setTimeout(() => (this.sheetDragging = false), 0);
    if (this.mapService.map) {
      setTimeout(() => this.mapService.map.invalidateSize(), 120);
    }
  }

  getVehicleStatus(vehicle: Vehicule): 'route' | 'arret' | 'panne' {
  switch (vehicle.etat) {
    case 'green':
      return 'route';
    case 'red':
    case 'blue': // temporary stop — still treat as "arrêt" visually
      return 'arret';
    case 'gray':
    case 'panne':
    default:
      return 'panne';
  }
}

getDriverName(vehicle: Vehicule): string {
  if (vehicle.driverName) {
    return vehicle.driverName;
  }
  if (vehicle.driver && (vehicle.driver.firstName || vehicle.driver.lastName)) {
    return [vehicle.driver.firstName, vehicle.driver.lastName].filter(Boolean).join(' ');
  }
  return '';
}

getLastUpdateLabel(vehicle: Vehicule): string {
  const date = this.getVehicleRecordDate(vehicle);
  if (!date) {
    return this.translate.instant('REALTIME.noData');
  }

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hour = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  // Today → time only; otherwise → date only (same as map popup style pieces).
  if (this.isSameCalendarDay(date, new Date())) {
    return `${hour}:${minutes}`;
  }
  return `${day}/${month}/${year}`;
}

isLastUpdateToday(vehicle: Vehicule): boolean {
  const date = this.getVehicleRecordDate(vehicle);
  return !!date && this.isSameCalendarDay(date, new Date());
}

hasVehicleTemperature(vehicle: Vehicule): boolean {
  return this.signinService.hasVehicleTemperatureOption(vehicle) && this.getVehicleTemperature(vehicle) !== null;
}

getVehicleTemperature(vehicle: Vehicule): string | null {
  const rt = this.getVehicleRtSource(vehicle)?.realTimeRecord;
  if (!rt) {
    return null;
  }

  const rawTemp = rt.temperature;
  if (rawTemp != null && String(rawTemp).trim() !== '' && String(rawTemp).toLowerCase() !== 'null') {
    const parsed = Number(rawTemp);
    if (!isNaN(parsed)) {
      return `${parsed} °C`;
    }
    const text = String(rawTemp).trim();
    return /°\s*c/i.test(text) ? text : `${text} °C`;
  }

  if (rt.temp_engine != null && !isNaN(Number(rt.temp_engine))) {
    return `${Number(rt.temp_engine)} °C`;
  }

  return null;
}

/** Same speed source/value as the map vehicle popup. */
getVehicleSpeed(vehicle: Vehicule): number {
  const source = this.getVehicleRtSource(vehicle);
  return source?.realTimeRecord != null ? source.realTimeRecord.speed : 0;
}

private getVehicleRtSource(vehicle: Vehicule): Vehicule {
  const dm = this.realTimeWorker.dataManagementService;
  const selected = dm.selectedVehicule;
  if (selected?.realTimeRecord && this.isSameVehicle(selected, vehicle)) {
    return selected;
  }
  return vehicle;
}

private getVehicleRecordDate(vehicle: Vehicule): Date | null {
  const rt = this.getVehicleRtSource(vehicle)?.realTimeRecord;
  if (!rt?.recordTime) {
    return null;
  }
  const date = new Date(rt.recordTime);
  return isNaN(date.getTime()) ? null : date;
}

private isSameCalendarDay(a: Date, b: Date): boolean {
  return a.getFullYear() === b.getFullYear()
    && a.getMonth() === b.getMonth()
    && a.getDate() === b.getDate();
}

private isSameVehicle(a: Vehicule, b: Vehicule): boolean {
  if (a.idVehicule != null && b.idVehicule != null && a.idVehicule === b.idVehicule) {
    return true;
  }
  const aDevice = a.device?.idDevice ?? a.idDevice;
  const bDevice = b.device?.idDevice ?? b.idDevice;
  if (aDevice != null && bDevice != null && aDevice === bDevice) {
    return true;
  }
  const aRt = a.realTimeRecord?.idRealTimeRecord;
  const bRt = b.realTimeRecord?.idRealTimeRecord;
  return aRt != null && bRt != null && aRt === bRt;
}

  private getPointerY(ev: MouseEvent | TouchEvent): number {
    if (ev instanceof MouseEvent) {
      return ev.clientY;
    }
    const touch = ev.touches[0] || ev.changedTouches[0];
    return touch ? touch.clientY : 0;
  }
  
  // Clicking the "Temps réel" nav item toggles the search bar:
  // first click shows it, clicking again hides it.
  onRealtimeNavClick() {
    const searchBarShown =
      this.activeView === 'realtime' && this.panelVisible && this.showSearchBar && !this.showVehicleList;

    if (searchBarShown) {
      this.closeVehicleList();
      setTimeout(() => {
        if (this.mapService.map) {
          this.mapService.map.invalidateSize();
        }
      }, 250);
      return;
    }

    this.showRealtimeMap();
  }

  // Show the realtime view with the search bar (Temps réel nav / diamond / external request).
  showRealtimeMap() {
    this.activeView = 'realtime';
    this.panelVisible = true;
    this.showVehicleList = false;
    this.showSearchBar = true;
    this.sheetHeight = this.searchBarHeight;

    if (!this.mapService.map) {
      setTimeout(() => this.bootstrapRealtimeMap(), 100);
      return;
    }

    this.refreshRealtimeMapDisplay();
    setTimeout(() => {
      this.mapService.map?.invalidateSize(true);
    }, 150);
    setTimeout(() => this.refreshRealtimeMapDisplay(), 350);
  }

  toggleExpandGroup(group: any) {
    this.table.groupHeader.toggleExpandGroup(group);
  }

  onDetailToggle(event: any) {
    console.log('Detail Toggled', event);
  }

  toggleCluster() {
    this.realTimeWorker.getAllRealTimeRecords();
    this.mapService.grouped = !this.mapService.grouped;
    if (this.mapService.map != undefined) {
      if (this.mapService.grouped && this.mapService.map.hasLayer(this.mapService.markerclusterIndiv)) {
        this.mapService.map.removeLayer(this.mapService.markerclusterIndiv);
        this.mapService.map.addLayer(this.mapService.markercluster)
      } else if (!this.mapService.grouped && this.mapService.map.hasLayer(this.mapService.markercluster)) {
        this.mapService.map.removeLayer(this.mapService.markercluster);
        this.mapService.map.addLayer(this.mapService.markerclusterIndiv);
      }
    }
    localStorage.setItem('groupsView', this.mapService.grouped.toString());
    // this.router.navigateByUrl('/client', { skipLocationChange: true }).then(() => {
    //   this.router.navigate([this.router.url]);
    // });
    // window.location.reload();
  }

  openVehicleList() {
    this.activeView = 'realtime';
    this.panelVisible = true;
    this.showVehicleList = true;
    this.sheetHeight = this.maxSheetHeight;
    this.expandAllGroups();
  }

  closeVehicleList() {
    this.showVehicleList = false;
    this.showSearchBar = false;
    this.sheetHeight = this.minSheetHeight;
    this.panelVisible = false;
  }

  toggleVehicleList() {
    if (this.showVehicleList) {
      this.closeVehicleList();
    } else {
      this.openVehicleList();
    }
  }

  clearSearch() {
    this.searchVehicule = '';
    this.realTimeWorker.setFilteredVehchiles('');
  }

  expandItem(group: Group) {
    const groupId = group.idGroupe;
    if (this.openGroupIds.has(groupId)) {
      this.openGroupIds.delete(groupId);
    } else {
      this.openGroupIds.add(groupId);
    }
  }

  isGroupOpen(group: Group): boolean {
    return this.openGroupIds.has(group.idGroupe);
  }

  private openAllGroupsInPanel(): void {
    const groups = this.realTimeWorker.dataManagementService.groups;
    if (!groups?.length) {
      return;
    }
    if (this.openGroupIds.size === 0) {
      groups.forEach(g => this.openGroupIds.add(g.idGroupe));
      return;
    }
    const validIds = new Set(groups.map(g => g.idGroupe));
    groups.forEach(g => this.openGroupIds.add(g.idGroupe));
    [...this.openGroupIds].forEach(id => {
      if (!validIds.has(id)) {
        this.openGroupIds.delete(id);
      }
    });
  }

  expandAllGroups() {
    this.realTimeWorker.dataManagementService.groups?.forEach(g => this.openGroupIds.add(g.idGroupe));
  }

  async goToRealTimeRecord(group: Group, vehicule: Vehicule) {
    await this.realTimeWorker.goToRealTimeRecord(group, vehicule);
    this.showVehicleList = false;
    this.showSearchBar = false;
    this.sheetHeight = this.minSheetHeight;
    this.panelVisible = false;
    setTimeout(() => {
      if (this.mapService.map) {
        this.mapService.map.invalidateSize();
      }
    }, 250);
  }

  isVehicleFocused(): boolean {
    return this.realTimeWorker.trackingMode
      && !!this.realTimeWorker.dataManagementService.selectedVehicule;
  }

  getSelectedVehicleLabel(): string {
    const vehicule = this.realTimeWorker.dataManagementService.selectedVehicule;
    if (!vehicule) {
      return '';
    }
    return this.realTimeWorker.dataManagementService.getVehiculeName(vehicule);
  
  }

  clearVehicleSelection(): void {
    this.mapService.map?.closePopup();
    this.realTimeWorker.resetForGlobalView();
    this.stateservice.setSelectedMarker(null);
    this.stateservice.updateState(ZoomState.Default);
  }


  getVehicleBadgeBottom(): number {
    const sheetH = (this.sheetDragging || this.showVehicleList || this.showSearchBar || this.panelVisible)
      ? this.sheetHeight
      : this.minSheetHeight;
    return sheetH + 6;
  }

  async openDashborad() {
    const modal = await this.modalController.create({
      component: DashboradComponent,
      cssClass: 'details'
    });

    return await modal.present();
  }


  async arreterDemarrer(ev: any) {
    let vehicule = this.realTimeWorker.dataManagementService.selectedVehicule!.idDevice;
    let group = this.realTimeWorker.dataManagementService.selectedGroup;
    let selectedV = { "group": group, "vehicule": vehicule, "indexGroup": this.id1, "indexVehicule": this.id2 };

    let popover = await this.popoverCtrl.create({
      component: PromptComponent,
      event: ev,
      translucent: false,
      cssClass: 'marcheArret'
    });
    return await popover.present();
  }

  currentPosition() {
    let vehicules = this.realTimeWorker.getVehicule(this.realTimeWorker.dataManagementService.selectedVehicule!.idDevice);

    if (!this.isClicked) {

      //update state
      this.stateservice.setSelectedMarker(L.latLng(this.popupService.currentlocationlat, this.currentlocationlng));
      this.stateservice.updateState(ZoomState.currentPosition);

      //this.mapService.map.flyTo(L.latLng(this.popupService.currentlocationlat, this.currentlocationlng), 15);
      this.positionMarker = L.marker([this.popupService.currentlocationlat, this.currentlocationlng]).addTo(this.mapService.map);

      this.circle = L.circle([this.popupService.currentlocationlat, this.popupService.currentlocationlng], {
        fillOpacity: 0.2,
        radius: 500
      }).addTo(this.mapService.map);

      this.isClicked = !this.isClicked;
    }
    else {
      this.mapService.map.removeLayer(this.positionMarker);
      this.mapService.map.removeLayer(this.circle);
      //this.mapService.map.setView(L.latLng(vehicules[0].realTimeRecord.coordinate.lat, vehicules[0].realTimeRecord.coordinate.lng), 8);
      //update state
      this.stateservice.setSelectedMarker(vehicules[0]);


      this.isClicked = !this.isClicked;
    }

  }
  drawpath() {
    if (this.realTimeWorker.dataManagementService.selectedVehicule!) {
      let vehicules = this.realTimeWorker.getVehicule(this.realTimeWorker.dataManagementService.selectedVehicule!.idDevice);
      if (this.popupService.currentlocationlat && this.popupService.currentlocationlng) {
        let options: LaunchNavigatorOptions = {
          start: [this.popupService.currentlocationlat, this.popupService.currentlocationlng],
          app: LaunchNavigator.APP.GOOGLE_MAPS

        };
        LaunchNavigator.navigate([vehicules[0].realTimeRecord.coordinate.lat,
          vehicules[0].realTimeRecord.coordinate.lng], options)
          .then(
            success => console.log('Launched navigator'),
            error => this.handleError(this.translate.instant('REALTIME.installGoogleMaps'))
          );
      } else {
        this.handleError(this.translate.instant('REALTIME.enableGps'))

      }
    } else {
      this.handleError(this.translate.instant('REALTIME.chooseVehicle'))
    }

  }
  async handleError(mess: String) {
    let alert = await this.alertCtrl.create({
      message: '' + mess,
      buttons: ['Ok']
    });
    await alert.present();
  }
  voirHistorique() {
    this.hideCurrentPath = true
    this.hideRTPath = true
    this.router.navigate(['/path']);
  }

  displayTodaysMileage(vehicule: Vehicule) {
    this.hideCurrentPath = true
    this.hideRTPath = true
    this.realTimeWorker.displayTodaysMileage(vehicule);
  }

  displayCurrentPath(deviceId: number) {
    this.hideRTPath = true
    this.hideCurrentPath = false
    if (this.realTimeWorker.getVehicule(this.realTimeWorker.dataManagementService.selectedVehicule!.idDevice)[0].realTimeRecord.ignition == true) {
      this.realTimeWorker.displayCurrentPath(deviceId);
      let lat = this.realTimeWorker.getVehicule(this.realTimeWorker.dataManagementService.selectedVehicule!.idDevice)[0].realTimeRecord.coordinate.lat
      let lng = this.realTimeWorker.getVehicule(this.realTimeWorker.dataManagementService.selectedVehicule!.idDevice)[0].realTimeRecord.coordinate.lng
      this.mapService.centerMapMarker(lat, lng);
    }

  }


  closePopupSide() {
    this.realTimeWorker.resetForGlobalView();
    this.trameRtTrack = []
    this.popupService.hideCurrentPath = true
    this.popupService.showBackButton = false
    this.mapService.map.closePopup();
    this.stateservice.zoomCounter = 0;
    if (this.popupService.isClicked) {

      this.mapService.map.removeLayer(this.popupService.positionMarker);
      this.mapService.map.removeLayer(this.popupService.circle);
      ////////////retour au voiture selectee  meme apres manipulation du carte
      // this.mapService.map.setView(L.latLng(vehicules[0].realTimeRecord.coordinate.lat, vehicules[0].realTimeRecord.coordinate.lng), 8);
      this.popupService.isClicked = !this.popupService.isClicked;

    }
    try {
      //this.mapService.centerMap(this.realTimeWorker.allRealTimeRecords, 17);
      this.stateservice.updateState(ZoomState.Default);
    } catch (e) {
      console.error('Error while centering the map:', e);

    }
    this.mapService.removePolylinesFromMap();
    this.mapService.removeMarkersFromMap();
    this.popupService.stopPlayback();

  }
  closePopupManipulation() {
    this.closePopupSide();
    this.popupService.hideCurrentPath = true
    this.popupService.showBackButton = false
    this.mapService.map.closePopup()
    if (this.popupService.isClicked) {
      this.mapService.map.removeLayer(this.popupService.positionMarker);
      this.mapService.map.removeLayer(this.popupService.circle);
      this.popupService.isClicked = !this.popupService.isClicked;
    }
    try {
      //this.mapService.centerMap(this.realTimeWorker.allRealTimeRecords, 17);
      this.stateservice.updateState(ZoomState.Default);
    } catch (e) {
      console.error('Error while centering the map:', e);
    }
    this.mapService.removePolylinesFromMap();
    this.mapService.removeMarkersFromMap();
  }

  /* returnToSelectedVehicule() {
     let vehicule = this.realTimeWorker.dataManagementService.selectedVehicule;
     this.popupService.showBackButton = false
     this.popupService.hideCurrentPath = true
     this.popupService.stopPlayback();
     this.mapService.removePolylinesFromMap();
     this.mapService.removeMarkersFromMap();
     if (this.popupService.isClicked) {
       this.mapService.map.removeLayer(this.popupService.positionMarker);
       this.mapService.map.removeLayer(this.popupService.circle);
       this.mapService.map.setView(L.latLng(vehicule!.realTimeRecord.coordinate.lat, vehicule!.realTimeRecord.coordinate.lng), 8);
       this.popupService.isClicked = !this.popupService.isClicked;
     }
    // this.mapService.map.setView(this.realTimeWorker.dataManagementService.selectedVehicule!.realTimeRecord.coordinate, 17);
   }
 */
  getRealTimePath() {
    this.hideRTPath = false;
    this.hideCurrentPath = true;
    if (this.realTimeWorker.dataManagementService.selectedVehicule) {
      let idDevice = this.realTimeWorker.dataManagementService.selectedVehicule!.idDevice

      let vehicule = this.realTimeWorker.getVehicule(idDevice)[0]
      let speed = vehicule.realTimeRecord.speed
      if (vehicule.realTimeRecord.ignition == true
        && this.lngBegin && this.latBegin && this.clickTrackDate) {
        this.realTimeWorker.displayRTPath(idDevice, this.latBegin, this.lngBegin, this.clickTrackDate, speed);
      }

    }
  }

  getCurrentVehiculePosition() {
    let vehicule = this.realTimeWorker.getVehicule(this.realTimeWorker.dataManagementService.selectedVehicule!.idDevice)[0]

    this.latBegin = vehicule.realTimeRecord.coordinate.lat;
    this.lngBegin = vehicule.realTimeRecord.coordinate.lng;
    this.clickTrackDate = new Date()

  }

  initTimerCurrentPath() {
    clearTimeout(this.liveReloadingRT);
    let idDevice = this.realTimeWorker.getVehicule(this.realTimeWorker.dataManagementService.selectedVehicule!.idDevice)[0].idDevice
    this.displayCurrentPath(idDevice);
    this.liveReloadingRT = setInterval(() => {
      if (this.hideCurrentPath == false) {
        this.displayCurrentPath(idDevice);
      }
    }, 20000);

  }

  cleanHistory() {
    const groups = this.realTimeWorker.dataManagementService.groups;
    if (groups && groups.length > 0) {
      const firstGroup = groups[0];
      this.realTimeWorker.dataManagementService.selectedGroup = firstGroup;
      if (firstGroup.vehicules && firstGroup.vehicules.length > 0) {
        this.realTimeWorker.dataManagementService.selectedVehicule = firstGroup.vehicules[0];
      }
    }
  }


  trackByGroupId(index: number, group: Group): any {
    return group.idGroupe;
  }

  trackByVehicleId(index: number, vehicle: Vehicule): any {
    return vehicle.idDevice;
  }

  ngDoCheck() {
    if (this.showVehicleList) {
      console.count('CD tick while list open');
    }
  }

  // ---------------- Generic diamond-button toggle ----------------

  // Called by the historical submenu when the user picks a historique option
  // (e.g. "Trajets", "Kilometrage journalier", etc.). `kind` should identify
  // which one, so the template/child component can render the right list.
  // NOTE: wire this into app-historical-submenu's (choiceSelected) or similar
  // output once that component is available.
  openHistoriquePanel(kind: string, data: any = null) {
    this.activeView = 'historique';
    this.activeHistoriqueKind = kind;
    this.historiqueData = data;
    this.panelVisible = true;

    this.showVehicleList = false;
    this.showSearchBar = false;
    this.sheetHeight = this.maxSheetHeight;
  }

  // The diamond button: toggles visibility of whatever is currently active
  // (realtime vehicle list OR historique panel), without switching between them.
  centerMenuClick() {
    this.panelVisible = !this.panelVisible;

    if (this.activeView === 'realtime') {
      this.showVehicleList = this.panelVisible;
      this.showSearchBar = this.panelVisible;
    }
    this.sheetHeight = this.panelVisible ? this.maxSheetHeight : this.minSheetHeight;

    if (this.mapService.map) {
      setTimeout(() => this.mapService.map.invalidateSize(), 150);
    }
  }

}
